import React from 'react'
import { useMedia } from 'sb-hooks'
import { scrollToElement } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Image from 'components/_new/ui/Image/Image'
import Button from 'components/_new/Button/Button'
import Text from 'components/_new/typography/Text/Text'
import { WidthContainer } from 'components/_new/layout/widthContainer'

import messages from './messages'
import s from './LastBlock.scss'

// resolve picture x2
import womanImage from './images/woman.png'
// resolve picture x2
import womanMobileImage from './images/woman-mobile.png'


const handleButtonClick = () => {
  scrollToElement('selectGender', true)
}

const GiftPageLastBlock = () => {
  const { isMobile, isDesktop } = useMedia()

  return (
    <Box className={s.wrapper} alignCenter={isMobile} pt={isMobile ? '24' : null}>
      <WidthContainer className={s.container}>
        <div className={s.content}>
          <Text size="32-40" semibold message={messages.text} />
          <Box mt="36">
            <Button
              title={messages.buttonTitle}
              size="md"
              color="brand"
              fullWidthOnMobile
              rightIcon={isDesktop && 'rightArrowSmall'}
              onClick={handleButtonClick}
            />
          </Box>
        </div>
        <Box className={s.imageContainer} mt={isMobile ? '24' : null}>
          <Image {...(isMobile ? womanMobileImage : womanImage)} />
        </Box>
      </WidthContainer>
    </Box>
  )
}


export default GiftPageLastBlock
